import React, { useContext, useEffect, useState } from 'react';

import { createStyles, makeStyles, Theme } from '@material-ui/core/styles';

import ConfirmAlert from '../../components/confirm-alert';
import ConfirmSelect from '../../components/confirm-select';
import SaveBackdrop from '../../components/saveBackdrop';
import Screen from '../../components/screen';
import SplashWait from '../../components/splash-wait';
import { AppContext } from '../../contexts/app-context';
import { HtmlContent } from '../../global-component-styles';
import GlobalStyles from '../../global-styles';
import API from '../../utils/api';
import {
  apiReponseError, apiRequestError, canReadProgram, checkUserAuthenticated, clearLocalStorage,
  getUserAssignedPrograms, goToRoutePage, isITTeam, openExternalLink, openExternalLinkWithTarget,
  redirectRoutePage, setWindowTitle
} from '../../utils/helper';
import {
  ArrowRightAltIcon, BlurOnIcon, CloseIcon, ContractOrderIcon, HomeBackgroundImage1,
  HomeBackgroundImage2, HomeBackgroundImage3, JobIcon, LookUpArrowIcon, MainMenuDisplayAsIcon,
  MainMenuDisplayAsListIcon, ManageSettingsIcon, MeshifyImage, OnboardingIcon, OptoutIcon,
  OrderIcon, PendingEnrollmentIcon, PreorderIcon, Program360Image, RechargeLogoImage,
  ReplacementIcon, SavesIcon, SendGridLogoImage, ShopifyLogoImage, SubscriptionIcon, TwilioImage,
  UploadIcon, UserAssignedProgramsIcon, ValidationIcon
} from '../../utils/icons';
import {
  Alert, Avatar, Badge, Box, Button, ButtonBase, Grid, Hidden, IconButton, Tooltip, Typography
} from '../../utils/material-ui-core';

const Home = () => {
  const pageStyles = LocalPageStyles();
  const globalStyles = GlobalStyles();

  const { showAlert, appStatus, userActionPendings, writeLog, appVersionMisMatch, espJobs, appDataReady, userFunctionAccess, isUserAuthenticated, appRoutePaths, clientCompanies, programs, kits, skus, enlistmentPartners, setOnboardingPagePathName, appSetting, pendingEnrollmentCompanies, refreshData, internal, userSelectedProgramCodesNote } = useContext(AppContext);
  const [loading, setLoading] = useState<boolean>(true);
  const [backgroundImageId, setBackgroundImageId] = useState<number>(1);
  const [showBulletinContent, setShowBulletinContent] = useState<boolean>(false);
  const [isMainMenuContentVisible, setIsMainMenuContentVisible] = useState<boolean>(true);
  const [openAppMisMatchConfirmAlert, setOpenAppMisMatchConfirmAlert] = useState<boolean>(true);
  const [userAssginedprogramLookupValues, setUserAssginedprogramLookupValues] = useState<LookupWithCategory[]>([]);
  const [openUserAssginedprogramsDialog, setOpenUserAssginedprogramsDialog] = useState<boolean>(false);
  const [saveInProgress, setSaveInProgress] = useState<boolean>(false);


  const confirmUserAssignedProgramsDialog = async (confirmOutput: ConfirmOutput) => {
    setOpenUserAssginedprogramsDialog(false);
    if (confirmOutput.status === "select") {
      const programKeys: any[] = [];
      (confirmOutput.data as LookupWithCategory[]).forEach(program => {
        programKeys.push(String(program.value));
      });

      const payload = {
        programKeys: programKeys
      }

      try {
        setSaveInProgress(true);
        await API.post("/api/admin/user/assigned/programs", payload)
          .then(async (response) => {
            setSaveInProgress(false);
            showAlert({ message: "Successfully saved.", severity: "success" });
            redirectRoutePage("");
            return;
          })
          .catch((error) => {
            setSaveInProgress(false);
            showAlert({
              message: apiReponseError(error, "Failed to save user assigned programs."),
              severity: "error",
            });
          });
      }
      catch (e) {
        setSaveInProgress(false);
        showAlert({
          message: apiRequestError(e, "Something went wrong in our system."),
          severity: "error",
        });
      }
    }
  }

  const showUserAssignedPrograms = async () => {

    setSaveInProgress(true);
    const apiResponse = await getUserAssignedPrograms();
    setSaveInProgress(false);
    if (apiResponse.success) {

      if (apiResponse.data.userAssignedPrograms != null) {

        const data = apiResponse.data.userAssignedPrograms as UserAssignedProgram[];
        const lookupValues: LookupWithCategory[] = [];
        data.forEach(program => {
          lookupValues.push({
            name: program.programCode + " - " + program.programName,
            value: program.programKey,
            category: program.clientCompanyName,
            checked: program.selected
          });
        });

        setUserAssginedprogramLookupValues(lookupValues);
        setOpenUserAssginedprogramsDialog(true);
      }
    }
    else {
      showAlert({ message: apiResponse.errorMessage, severity: "error" });

    }
  }

  const gotoOnboarding = (title: string) => {
    const url = "onboarding";
    if (title === "Enrollment") {
      openExternalLink(appSetting.meshifyUrl + "/dashboard3#folders?folderId=0");
      return;
    } else if (title === "Jobs") {
      goToRoutePage("jobs");
      return;
    }
    setOnboardingPagePathName(title);
    goToRoutePage(url);
  };

  const gotoMenu = (title: string) => {
    setTimeout(() => {
      goToRoutePage(title);
    }, 100);
    return;
  };

  const getVendors = () => {
    const vendors: any[] = []

    vendors.push({ url: appSetting.meshifyUrl, targetName: "meshify", image: MeshifyImage });
    vendors.push({ url: "https://www.shopify.com", targetName: "shopify", image: ShopifyLogoImage });
    vendors.push({ url: "https://rechargepayments.com", targetName: "rechargepayments", image: RechargeLogoImage });
    vendors.push({ url: "https://www.twilio.com", targetName: "twilio", image: TwilioImage });
    vendors.push({ url: "https://sendgrid.com", targetName: "sendgrid", image: SendGridLogoImage });

    return vendors;
  }

  const getAppAccessItemIcon = (title: string, size: any) => {
    if (size === undefined || size === "") {
      size = "default";
    }

    if (title === "Onboarding") return <OnboardingIcon color="secondary" fontSize={size} />;
    else if (title === "Subscription") return <SubscriptionIcon color="secondary" fontSize={size} />;
    else if (title === "Replacement") return <ReplacementIcon color="secondary" fontSize={size} />;
    else if (title === "Manual Orders") return <OrderIcon color="secondary" fontSize={size} />;
    else if (title === "Jobs & Log") return <JobIcon color="secondary" fontSize={size} />;
    else if (title === "Validation") return <ValidationIcon color="secondary" fontSize={size} />;
    else if (title === "Manage Settings") return <ManageSettingsIcon color="primary" fontSize={size} />;
    else if (title === "Enlistment Reviews") return <PendingEnrollmentIcon color="secondary" fontSize={size} />;
    else if (title === "Enrollment Correction") return <PendingEnrollmentIcon color="secondary" fontSize={size} />;
    else if (title === "Upload Enrollment File") return <UploadIcon color="secondary" fontSize={size} />;
    else if (title === "Saves") return <SavesIcon color="secondary" fontSize={size} />;
    else if (title === "Contract Orders") return <ContractOrderIcon color="secondary" fontSize={size} />;
    else if (title === "Preorder Corrections") return <PreorderIcon color="secondary" fontSize={size} />;
    else if (title === "Account Optout") return <OptoutIcon color="secondary" fontSize={size} />;
    return <OnboardingIcon color="action" fontSize={size} />;
  };


  const refreshSite = () => {
    window.location.reload();
  };

  const setMainMenuContentVisible = () => {

    var tempIsMainMenuContentVisible = !isMainMenuContentVisible;

    if (tempIsMainMenuContentVisible) {
      window.localStorage.setItem("MainMenuContentVisible", "1");
    }
    else {
      window.localStorage.setItem("MainMenuContentVisible", "0");
    }
    setIsMainMenuContentVisible(tempIsMainMenuContentVisible);

  }

  const setBackgroundImage = () => {
    let homeBackgroundId = localStorage.getItem("HomeBackgroundId")

    if (homeBackgroundId === "1") {
      homeBackgroundId = "2";
    }
    else if (homeBackgroundId === "2") {
      homeBackgroundId = "3";
    }
    else if (homeBackgroundId === "3") {
      homeBackgroundId = "1";
    }
    else {
      homeBackgroundId = "1";
    }

    localStorage.setItem("HomeBackgroundId", homeBackgroundId);
    setBackgroundImageId(Number(homeBackgroundId));
  }


  useEffect(() => {
    writeLog("Home Page", "", "", "");
    setWindowTitle("Home");
    window.scrollTo(0, 0);

    if (appVersionMisMatch) {
      clearLocalStorage("", false);
      setOpenAppMisMatchConfirmAlert(true);
      return;
    } else {
      setOpenAppMisMatchConfirmAlert(false);
    }



    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [appVersionMisMatch]);

  useEffect(() => {
    let startPagePath: string | undefined | null = "";
    let startPrevPagePath: string | undefined | null = "";
    let startPagePathCounter: number | undefined | null = 0;

    startPagePath = localStorage.getItem("startPagePath");
    startPrevPagePath = localStorage.getItem("startPrevPagePath");
    startPagePathCounter = Number(localStorage.getItem("startPagePathCounter"));

    if (startPagePathCounter === null || startPagePathCounter === undefined) {
      startPagePathCounter = 0;
    }

    startPagePathCounter++;

    if (startPagePathCounter >= 3) {
      localStorage.removeItem("startPagePath");
      localStorage.removeItem("startPrevPagePath");
      localStorage.removeItem("startPagePathCounter");
      goToRoutePage("home");
      return;
    }

    localStorage.setItem("startPagePathCounter", String(startPagePathCounter));

    if (startPagePath === null || startPagePath === undefined || startPagePath === "" || startPagePath === "redirectPage/") {
      startPagePath = "";
    }

    if (startPrevPagePath === null || startPrevPagePath === undefined || startPrevPagePath === "" || startPagePath === "redirectPage/") {
      startPrevPagePath = "";
    }

    if (startPagePath.toLowerCase().indexOf("home") >= 0) {
      startPagePath = "";
      startPrevPagePath = "";
    }

    if (startPagePath.toLowerCase().indexOf("login") >= 0) {
      startPagePath = "";
      startPrevPagePath = "";
    }

    if (startPagePath.toLowerCase().indexOf("locked") >= 0) {
      startPagePath = "";
      startPrevPagePath = "";
    }

    if (startPagePath === "" && startPrevPagePath === "") {
      localStorage.removeItem("startPagePath");
      localStorage.removeItem("startPrevPagePath");
    } else {
      if (startPagePath === startPrevPagePath) {
        startPagePath = "";
      }

      localStorage.setItem("startPagePath", "");
      localStorage.setItem("startPrevPagePath", startPagePath);

      if (startPagePath !== "" && startPagePath !== startPrevPagePath) {
        localStorage.removeItem("startPagePath");
        localStorage.removeItem("startPrevPagePath");
        if (startPagePath !== undefined) {
          goToRoutePage(startPagePath);
          return;
        }
      }

      if (startPagePath === "") {
        localStorage.removeItem("startPagePath");
        localStorage.removeItem("startPrevPagePath");
      }


    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  useEffect(() => {
    const initialPageAsync = async () => {
      checkUserAuthenticated(isUserAuthenticated);

      if (isUserAuthenticated && appStatus.locked) {
        goToRoutePage("locked");
        return;
      }

      setBackgroundImage();

      if (isUserAuthenticated && appDataReady) {
        var tempIsMainMenuContentVisible = window.localStorage.getItem("MainMenuContentVisible");

        if (tempIsMainMenuContentVisible === "1") {
          setIsMainMenuContentVisible(true);
        }
        else if (tempIsMainMenuContentVisible === "0") {
          setIsMainMenuContentVisible(false);
        }

        refreshData("useractions")
        setLoading(false);

        localStorage.removeItem("startPagePathCounter");
      }
    };

    initialPageAsync();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [isUserAuthenticated, appDataReady, clientCompanies, programs, kits, skus, enlistmentPartners, pendingEnrollmentCompanies, espJobs]);

  return (
    <React.Fragment>
      <>
        <ConfirmAlert open={openAppMisMatchConfirmAlert} content={"A new version of Sensor Admin is available."} okText="UPDATE NOW" callbackOnClose={refreshSite} />

        {loading || appVersionMisMatch ? (
          <SplashWait />
        ) : (
          <Screen>
            <SaveBackdrop open={saveInProgress} />
            <ConfirmSelect
              title="Select Programs"
              label={"Programs"}
              content={``}
              data={userAssginedprogramLookupValues}
              yesText="SELECT"
              noText="CANCEL"
              open={openUserAssginedprogramsDialog}
              multiSelect={true}
              maxSelect={0}
              callbackOnSelect={confirmUserAssignedProgramsDialog}
            />

            <Grid container spacing={0}>

              {/* Application Lock Message */}
              {appStatus.note !== "" ? (
                <Grid item xs={12}>
                  <Alert severity="warning" variant="filled">
                    <HtmlContent dangerouslySetInnerHTML={{ __html: appStatus.note }}></HtmlContent>
                  </Alert>
                  <Box p={2}></Box>
                </Grid>
              ) : null}

              {/* Bulletin Message */}
              {
                appStatus.bulletinTitle !== "" && appStatus.bulletinMessage !== "" ? (
                  <Grid item xs={12}>
                    <Alert severity="info" variant="standard" action={
                      <Button color="inherit" size="small" onClick={() => { setShowBulletinContent(!showBulletinContent) }}>
                        {showBulletinContent ? <CloseIcon /> : <LookUpArrowIcon />}
                      </Button>}>
                      <HtmlContent dangerouslySetInnerHTML={{ __html: appStatus.bulletinTitle }}></HtmlContent>
                    </Alert>

                    {
                      showBulletinContent ?
                        <Box className={pageStyles.lockedMessageContainer}>
                          <HtmlContent dangerouslySetInnerHTML={{ __html: appStatus.bulletinMessage }}></HtmlContent>
                        </Box>
                        : null
                    }
                    <Box p={2}></Box>
                  </Grid>
                )
                  : null
              }

              <Grid item xs={12}>
                <Grid container spacing={0}>

                  {/* Dashboard */}

                  <Grid item xs={12}>
                    <Box p={0} className={pageStyles.dashboardContainerOverlap}>

                      {
                        internal ?
                          <Box p={2} className={pageStyles.dashboardProgram360}>
                            {
                              canReadProgram(userFunctionAccess) ?
                                <Box className={pageStyles.program360}>
                                  <Tooltip title="Program 360 provides complete access to all client company information, program details, themes, metadata, and associated kits. It also highlights any issues or missing information at any time.">
                                    <Box display="flex" justifyContent="center" alignContent="center" style={{ paddingTop: '10px' }}
                                      onClick={() => { gotoOnboarding("Program 360") }}>
                                      <img src={Program360Image} alt="Logo" className={pageStyles.shaker} />
                                    </Box>
                                  </Tooltip>
                                </Box>
                                : null
                            }
                          </Box>
                          : null
                      }

                      <Box className={pageStyles.dashboardMobileHeaderContent}>
                        <Box className={pageStyles.dashboardHeader}>
                          Facilitates management of company onboarding, contract orders, enrollment corrections, enlistment approval, preorder corrections, loss prevention, manual order submissions, and more. Users have varying levels of security permissions to access these functions.
                        </Box>
                      </Box>

                      <Grid container spacing={0} className={backgroundImageId === 3 ? pageStyles.dashboardContainerBackground3 : backgroundImageId === 2 ? pageStyles.dashboardContainerBackground2 : pageStyles.dashboardContainerBackground1}>
                        <Grid item xs={12} sm={12} md={12} lg={9} >
                          <Box p={0} >
                            <Box p={0} className={pageStyles.dashboardContainer}>
                              <Grid container spacing={0}>
                                <Grid item xs={12}>
                                  <Grid container spacing={0}>
                                    <Grid item xs={12}>
                                      <Box className={pageStyles.dashboardHeaderContent}>
                                        <Box className={pageStyles.dashboardHeader}>
                                          Facilitates management of company onboarding, contract orders, enrollment corrections, enlistment approval, preorder corrections, loss prevention, manual order submissions, and more. Users have varying levels of security permissions to access these functions.
                                        </Box>
                                      </Box>
                                    </Grid>

                                    <Hidden only={["sm", "md", "lg", "xl"]}>
                                      <Grid item xs={12}>
                                        <Box p={10}>&nbsp;</Box>
                                      </Grid>
                                    </Hidden>
                                  </Grid>
                                </Grid>

                                <Hidden only={["xs"]}>
                                  <Grid item xs={12}>
                                    <Box p={2}>&nbsp;</Box>
                                    <Box p={2}>&nbsp;</Box>
                                  </Grid>
                                </Hidden>
                              </Grid>
                            </Box>
                          </Box>
                        </Grid>
                        <Grid item xs={12} sm={12} md={12} lg={3}>
                          {
                            internal ?
                              <Hidden only={['xs']}>
                                <Box p={1}>&nbsp;</Box>
                                {
                                  displayDashboardCounts(gotoOnboarding, pageStyles, userActionPendings)
                                }
                                <Box p={1}>&nbsp;</Box>
                              </Hidden>
                              : null
                          }
                        </Grid>
                      </Grid>
                    </Box>

                    {
                      internal ?
                        <Hidden only={['sm', 'md', 'lg', 'xl']}>
                          <Box p={1}>&nbsp;</Box>
                          <Box p={2} display="flex" flexDirection="row" alignContent="center">
                            <Box style={{ paddingTop: 0 }}>
                              <BlurOnIcon fontSize='small' />
                            </Box>
                            <Box>
                              <b>Key Data Points</b>
                            </Box>
                          </Box>
                          {
                            displayDashboardCounts(gotoOnboarding, pageStyles, userActionPendings)
                          }
                          <Box p={1}>&nbsp;</Box>
                        </Hidden>
                        : null
                    }
                  </Grid>

                </Grid>
              </Grid>

              {/* Menu card */}

              <Grid item xs={12}>
                <Grid container spacing={3}>
                  <Grid item xs={12}>
                    <Box p={3} display="flex" justifyContent='flex-end' alignContent='center' >

                      {
                        isITTeam(userFunctionAccess) ?
                          <Box >
                            <Tooltip title="Select which programs you want to use as default and apply them to user-specific functionalities.">
                              <IconButton onClick={showUserAssignedPrograms}>
                                {
                                  userSelectedProgramCodesNote !== "" ?
                                    <Badge badgeContent={userSelectedProgramCodesNote} color="secondary">
                                      <UserAssignedProgramsIcon color="primary" />
                                    </Badge>
                                    :
                                    <UserAssignedProgramsIcon color="secondary" />
                                }
                              </IconButton>
                            </Tooltip>
                          </Box>
                          : null
                      }

                      <Box >&nbsp;&nbsp;</Box>
                      <Box  >
                        <Tooltip title={!isMainMenuContentVisible ? "Display As List" : "Display As Icon"}>
                          <IconButton onClick={setMainMenuContentVisible}>
                            {
                              !isMainMenuContentVisible ? <MainMenuDisplayAsIcon color="primary" /> : <MainMenuDisplayAsListIcon color="primary" />
                            }
                          </IconButton>
                        </Tooltip>
                      </Box>
                    </Box>

                  </Grid>
                </Grid>

                {
                  !isMainMenuContentVisible ?
                    <Grid container spacing={0} style={{ animation: "slideFromRight 1s forwards", }}>
                      <Grid item xs={12}>&nbsp;</Grid>
                      {
                        appRoutePaths.map((item, index) => (
                          <Grid item xs={4} sm={3} md={2} lg={2} key={index} onClick={() => gotoMenu(item.path)}>
                            <Box display="flex" flexDirection="column" justifyItems="center" alignItems="center" textAlign="center">
                              <Box>
                                <ButtonBase>
                                  <Avatar variant="rounded" className={globalStyles.avatar}>
                                    {getAppAccessItemIcon(item.title, "medium")}
                                  </Avatar>
                                </ButtonBase>
                              </Box>
                              <Box className={pageStyles.mainMenuTitle2}>
                                {item.title}
                              </Box>
                            </Box>
                          </Grid>
                        ))
                      }
                      <Grid item xs={12}>&nbsp;</Grid>
                    </Grid>
                    :
                    <Grid container spacing={3} style={{ animation: "slideFromLeft 1s forwards", }}>
                      {appRoutePaths.map((item, index) => (
                        <Grid item xs={12} md={6} key={index} className={pageStyles.mainMenuContainer}>
                          <Box className={pageStyles.mainMenuLayout} onClick={() => gotoMenu(item.path)}>
                            <Grid container spacing={1}>
                              <Grid item xs={12}>
                                <Box display="flex" flexDirection="row" justifyContent="center" style={{ width: '100%' }}>
                                  <Box className={pageStyles.mainMenuImage}>
                                    <ButtonBase>
                                      <Avatar variant="rounded" className={globalStyles.avatar}>
                                        {getAppAccessItemIcon(item.title, "medium")}
                                      </Avatar>
                                    </ButtonBase>
                                  </Box>
                                  <Box style={{ width: '100%' }}>
                                    <Grid container spacing={1}>
                                      <Grid item xs={12} className={pageStyles.mainMenuTitle}>{item.title}</Grid>
                                      {
                                        isMainMenuContentVisible ?
                                          <Grid item xs={12} className={pageStyles.mainMenuContent}>
                                            <HtmlContent
                                              dangerouslySetInnerHTML={{
                                                __html: item.note,
                                              }}
                                            ></HtmlContent>
                                          </Grid>
                                          :
                                          null
                                      }
                                    </Grid>
                                  </Box>
                                  <Box className={pageStyles.mainMenuMoreContent} >
                                    <Box display="flex" className={pageStyles.mainMenuMore}>
                                      <ArrowRightAltIcon fontSize="medium" />
                                    </Box>
                                  </Box>
                                </Box>
                              </Grid>

                            </Grid>
                          </Box>
                        </Grid>
                      ))}
                    </Grid>
                }

              </Grid>

              {/* Vendor Links */}

              <Grid item xs={12} >
                <Box p={5}></Box>
                <Box display="flex" justifyContent="center" alignItems="center">
                  <Typography variant='h5'>External Vendors</Typography>
                </Box>
                <Box p={2}></Box>
                <Box className={pageStyles.vendorContainer}>
                  <Grid container spacing={3}>

                    {
                      getVendors().map((vendor, index) => (
                        <Grid item xs className={pageStyles.vendorCard} key={index}>
                          <Box display="flex" justifyContent="center" alignItems="center"
                            onClick={() => { openExternalLinkWithTarget(vendor.url, vendor.targetName) }}
                          >
                            <img src={vendor.image} alt="Logo" className={pageStyles.vendorLogoImage} />
                          </Box>
                        </Grid>
                      ))
                    }
                  </Grid>
                </Box>
              </Grid>
            </Grid>
          </Screen>
        )
        }
      </>
    </React.Fragment >
  );
};

const LocalPageStyles = makeStyles((theme: Theme) =>
  createStyles({
    "@keyframes dashboardContainerAnimation": {
      from: { width: "200%", opacity: 0 },
      to: { width: "100%", opacity: 0.9 },
    },
    mainMenuContainer: {
      padding: "20px",
      backgroundColor: theme.palette.type === "dark" ? "transparent" : "transparent",
      "& > :hover": {
        backgroundColor: theme.palette.type === "dark" ? theme.palette.grey[800] : theme.palette.grey[100],
        transition: "all 0.8s ease-in-out 0s",
        "& $mainMenuTitle": {
          color: theme.palette.type === "dark" ? theme.palette.primary.contrastText : "#000000",
        },
        "& $mainMenuMore": {
          display: 'block',
          color: theme.palette.type === "dark" ? theme.palette.secondary.light : theme.palette.secondary.dark,
        },
        "& $mainMenuImage": {
          "& svg": {
            color: theme.palette.type === "dark" ? theme.palette.secondary.contrastText : "#000000",
          },
        }
      }
    },
    mainMenuLayout: {
      padding: "20px",
      [theme.breakpoints.down("sm")]: {
        borderBottomWidth: 1,
        borderBottomStyle: "dashed",
        borderBottomColor: theme.palette.type === "dark" ? theme.palette.grey[800] : theme.palette.grey[300],
      }
    },
    mainMenuTitle: {
      fontSize: 20,
      fontWeight: "bolder",
      textTransform: "uppercase",
      letterSpacing: 2,
      color: theme.palette.type === "dark" ? theme.palette.grey[300] : theme.palette.grey[700],
      marginBottom: theme.spacing(1),
      marginTop: '8px',
      whiteSpace: "nowrap",
      overflow: "hidden",
      textOverflow: "ellipsis",
      [theme.breakpoints.down("xs")]: {
        fontSize: 18,
        letterSpacing: 1,
      },
    },
    mainMenuTitle2: {
      fontSize: 14,
      fontWeight: "bolder",
      textTransform: "uppercase",
      letterSpacing: 2,
      color: theme.palette.type === "dark" ? theme.palette.grey[300] : theme.palette.grey[700],
      marginBottom: theme.spacing(4),
      marginTop: '8px',
      [theme.breakpoints.down("xs")]: {
        fontSize: 12,
        letterSpacing: 1,
      },
    },
    mainMenuContent: {
      paddingBottom: '15px',
      lineHeight: '30px',
      [theme.breakpoints.up("sm")]: {
        minHeight: '60px',
      },
      [theme.breakpoints.down("xs")]: {
        fontSize: '0.9em',
        letterSpacing: 0.5,
      },
    },
    mainMenuMoreContent: {
      width: 60,
      borderWidth: 0,
      height: 'inherit',
      marginTop: 'auto',
      marginBottom: 'auto',
    },
    mainMenuMore: {
      display: 'none',
      textAlign: 'right',
    },
    mainMenuImage: {
      width: 60,
      marginBottom: theme.spacing(2),
    },
    newDashboardContent: {

      backgroundColor: theme.palette.type === "dark" ? theme.palette.grey[900] : theme.palette.grey[100],
      margin: '10px 10px 5px 10px',
      borderRadius: "5px",
      borderWidth: 3,
      borderColor: theme.palette.type === "dark" ? theme.palette.grey[900] : theme.palette.grey[200],
      borderStyle: "solid",
      boxShadow: '0px 2px 5px 0px rgba(254, 254, 254, 0.6)',
      opacity: theme.palette.type === "dark" ? 0.9 : 0.7,
      [theme.breakpoints.down("md")]: {
        maxWidth: '150px',
        marginLeft: 'auto',
        marginRight: 'auto',
      },

      [theme.breakpoints.down("xs")]: {
        boxShadow: 'none',
        margin: '10px 10px 5px 10px',
        backgroundColor: theme.palette.type === "dark" ? theme.palette.grey[800] : 'transparent',
        borderWidth: 3,
        borderBottomWidth: 2,
        borderColor: 'transparent',
        borderBottomColor: theme.palette.type === "dark" ? 'transparent' : theme.palette.grey[200],
        borderStyle: "solid",
      },

      "&:hover": {
        transition: "all 0.20s ease-in-out 0s",
        opacity: 1,
        backgroundColor: theme.palette.type === "dark" ? theme.palette.grey[700] : theme.palette.grey[400],
        borderColor: theme.palette.type === "dark" ? theme.palette.grey[700] : theme.palette.grey[400],
        "& $newDashboardTitle": {
          color: theme.palette.type === "dark" ? theme.palette.grey[100] : theme.palette.grey[900],
        }
      }
    },
    newDashboardCountTextColor: {
      color: theme.palette.type === "dark" ? theme.palette.secondary.light : theme.palette.secondary.light,
    },
    newDashboardCountActionTextColor: {
      color: theme.palette.type === "dark" ? theme.palette.primary.light : theme.palette.primary.light,
    },
    newDashboardCount: {
      animation: 'slideFromLeft 2s forwards',
      fontSize: 20,
      fontWeight: 'bolder',
      paddingTop: 10,
      paddingBottom: 10,
      [theme.breakpoints.up("lg")]: {
        fontSize: 30,
      },
      [theme.breakpoints.down("md")]: {
        fontSize: 30,
      },
      [theme.breakpoints.down("sm")]: {
        fontSize: 20,
      },
    },
    newDashboardTitle: {
      animation: 'slideFromDown 2s forwards',
      height: '40px',
      fontSize: 12,
    },
    dashboardContainerOverlap: {
      backgroundColor: theme.palette.type === "dark" ? "transparent" : "transparent",
      position: 'relative',
    },
    dashboardProgram360: {
      position: 'absolute',
      left: 0,
      bottom: 0,
      [theme.breakpoints.down("xs")]: {

      },
    },
    dashboardContainerBackground1: {
      backgroundImage: `url(${HomeBackgroundImage1})`,
      backgroundPosition: "center center",
      backgroundSize: '300%',
      animation: "zoomIn 3s forwards",
      [theme.breakpoints.up("sm")]: {
        paddingBottom: 30,
      },
    },
    dashboardContainerBackground2: {
      backgroundImage: `url(${HomeBackgroundImage2})`,
      backgroundPosition: "center center",
      backgroundSize: '300%',
      animation: "zoomIn 3s forwards",
      [theme.breakpoints.up("sm")]: {
        paddingBottom: 30,
      },
    },
    dashboardContainerBackground3: {
      backgroundImage: `url(${HomeBackgroundImage3})`,
      backgroundPosition: "center center",
      backgroundSize: '300%',
      animation: "zoomIn 3s forwards",
      [theme.breakpoints.up("sm")]: {
        paddingBottom: 30,
      },

    },
    dashboardContainer: {
      xposition: 'absolute',
      margin: 0,
      spacing: 0,
      paddingTop: 0,
      marginBottom: 10,
      paddingLeft: theme.spacing(2),
      paddingRight: theme.spacing(2),
      minHeight: 400,
      [theme.breakpoints.up("sm")]: {
        minHeight: 450,
      },
    },
    dashboardMobileHeaderContent: {
      display: "none",
      padding: 10,

      [theme.breakpoints.down("xs")]: {
        display: "block",
        //backgroundColor: theme.palette.type === "dark" ? theme.palette.grey[900] : theme.palette.grey[100],
      },

      "& $dashboardHeader": {
        color: theme.palette.type === "dark" ? theme.palette.grey[100] : theme.palette.grey[900],
        fontSize: 18,
      },
    },
    dashboardHeaderContent: {
      backgroundColor: "rgba(0,0,0, 0.4)",
      maxWidth: "900px",
      margin: "30px 20px",
      padding: "10px 20px",
      display: "none",
      [theme.breakpoints.up("sm")]: {
        display: "block",
      },
    },
    dashboardHeader: {
      maxWidth: "100%",
      color: theme.palette.grey[50],
      paddingTop: theme.spacing(2),
      paddingBottom: theme.spacing(2),
      textAlign: "left",
      fontSize: 16,
      [theme.breakpoints.up("sm")]: {
        fontSize: 20,
        maxWidth: "900px",
        xmarginBottom: 10,
      },

    },
    jobStatusHeader: {
      fontSize: 35,
      fontWeight: "bolder",
      marginBottom: theme.spacing(5),
      textAlign: "center",
      textTransform: "uppercase",
      [theme.breakpoints.up("xs")]: {
        fontSize: 25,
      },
    },
    vendorContainer: {
      paddingTop: 50,
      marginBottom: 100,
      backgroundColor: theme.palette.type === "dark" ? "transparent" : "transparent",
    },
    vendorImageContainer: {
      flexDirection: "row",
      [theme.breakpoints.down("sm")]: {
        flexDirection: "column",
      },
    },
    vendorCard: {
      justifyItems: "center",
      alignItems: "baseline",
      margin: "10px",
      padding: 20,
      height: "100px",
      xwidth: "200px",
      backgroundColor: theme.palette.type === "dark" ? "#ffffff" : "#ffffff",
      borderRadius: "3%",
      "& img": {
        width: "150px",
        height: "75px",
        xmaxWidth: "300px",
      },
    },
    vendorLogoImage: {
      marginLeft: 10,
      marginRight: 10,
      backgroundColor: theme.palette.type === "dark" ? "transparent" : "transparent",
      borderRadius: 4,
      cursor: "Pointer"
    },
    lockedMessageContainer: {
      textAlign: "left",
      backgroundColor: theme.palette.type === "dark" ? theme.palette.grey[800] : theme.palette.grey[100],
      padding: '15px 10px',
      "& h1": {
        fontSize: "0.9em",
        [theme.breakpoints.up("sm")]: {
          fontSize: "1em",
        },
      },
      "& p": {
        fontSize: "1em",
        letterSpacing: "1px",
      },
    },
    program360: {
      backgroundColor: theme.palette.primary.main,
      borderRadius: '5px',
      height: '75px',
      overflow: 'hidden',
      paddingLeft: 10,
      paddingRight: 10,
    },
    shaker: {
      transition: 'transform 0.5s ease-in-out',
      '&:hover': {
        animation: '$shake 0.5s',
      },
    },
    '@keyframes shake': {
      '0%': { transform: 'translateX(0)' },
      '25%': { transform: 'translateX(-5px)' },
      '50%': { transform: 'translateX(5px)' },
      '75%': { transform: 'translateX(-5px)' },
      '100%': { transform: 'translateX(0)' },
    },
  })
);

export default Home;

function displayDashboardCounts(gotoOnboarding: (title: string) => void, pageStyles, userActionPendings: UserActionPendingItem[]): React.ReactNode {

  return <>
    <Grid container spacing={0}>
      {userActionPendings.map((userActionPending, index) => (
        <Grid item xs={4} sm={3} md={3} lg={4} xl={4} key={index} className={pageStyles.shaker} >
          <Box display="flex" flexDirection="column" justifyItems="center"
            alignItems="center" textAlign="center" className={pageStyles.newDashboardContent} onClick={() => {
              if (userActionPending.access && userActionPending.url !== "") {
                goToRoutePage(userActionPending.url);
              }
            }}>

            <Box className={pageStyles.newDashboardCount}>
              <Box className={userActionPending.action ? pageStyles.newDashboardCountActionTextColor : pageStyles.newDashboardCountTextColor}>
                {userActionPending.count}
                {userActionPending.countPrefix}
              </Box>
            </Box>
            <Box className={pageStyles.newDashboardTitle}>
              <HtmlContent dangerouslySetInnerHTML={{ __html: userActionPending.title }}></HtmlContent>
            </Box>
          </Box>
        </Grid>

      ))
      }
    </Grid>
  </ >;
}

